export default "__VITE_ASSET__9sBfj2lH__"